<script setup lang="ts">
import { ConfirmDialog } from 'primevue'
import { useQrMenuStore } from '@/store/qr-menu'
import { quitIcon } from '@/assets/icons'

defineProps<{
  group: string
}>()

const qrMenuStore = useQrMenuStore()
</script>

<template>
  <ConfirmDialog :group="group" :draggable="false">
    <template #container="slotProps">
      <div class="confirmation" :style="qrMenuStore.themeVars">
        <div class="confirmation__header">
          <h1 class="font-18-n">{{ slotProps.message.header }}</h1>
          <VIcon
            :icon="quitIcon"
            class="confirmation__header-quit"
            @click="slotProps.rejectCallback"
          />
        </div>
        <p class="font-14-n">{{ slotProps.message.message }}</p>
        <div class="confirmation__footer">
          <Button
            severity="secondary"
            @click="slotProps.rejectCallback"
            class="font-12-n client-btn client-btn--secondary"
            fluid
          >
            {{ slotProps.message.rejectProps?.label || 'Отмена' }}
          </Button>
          <Button
            severity="primary"
            @click="slotProps.acceptCallback"
            class="font-12-n client-btn client-btn--primary"
            fluid
          >
            {{ slotProps.message.acceptProps?.label || 'ОК' }}
          </Button>
        </div>
      </div>
    </template>
  </ConfirmDialog>
</template>

<style scoped lang="scss">
.confirmation {
  padding: 1.4rem 1.6rem;
  max-width: 40rem;
  margin: 0 auto;

  &__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 1.6rem;

    h1 {
      color: var(--text-color);
    }

    &-quit {
      color: var(--text-color);
      width: 2rem;
      height: 2rem;
      cursor: pointer;
      transform: translate(0.6rem, -0.6rem);
    }
  }

  &__footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 2rem;
    gap: 1rem;
  }

  p {
    color: var(--text-color);
  }
}
</style>
